var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"items":_vm.breadcrumbItems,"hasBreadcrumb":"","hasBackButton":""}}),_c('form',[_c('b-card',{staticClass:"mc-card__setting"},[_c('b-tabs',{attrs:{"content-class":"p-3 text-muted","nav-wrapper-class":"mc-tab"}},[(_vm.hasAccessAll(['c3a-default-setkendaraan:read', 'vehicle_categories:read']))?_c('FleetCategory',{ref:"fleetCat",attrs:{"status":"FleetCategory"}}):_vm._e(),(
            _vm.hasAccessAll([
              'c3a-default-setkendaraan:read',
              'vehicle_type:create',
              'vehicle_type:read',
              'vehicle_type:update',
              'vehicle_type:delete',
            ])
          )?_c('FleetType',{ref:"fleetType",attrs:{"status":"FleetType"}}):_vm._e(),(
            _vm.hasAccessAll([
              'c3a-default-setkendaraan:read',
              'box_types:create',
              'box_types:read',
              'box_types:update',
              'box_types:delete',
            ])
          )?_c('BoxType',{ref:"fleetBox",attrs:{"status":"BoxType"}}):_vm._e(),(
            _vm.hasAccessAll([
              'c3a-default-setkendaraan:read',
              'thermo_types:read',
              'thermo_types:create',
              'thermo_types:update',
              'thermo_types:delete',
            ])
          )?_c('TermoType',{ref:"fleetThermo",attrs:{"status":"TermoType"}}):_vm._e(),(_vm.hasAccessAll(['fuel_type_price:read', 'fuel_type_price:update']))?_c('FuelType',{ref:"fleetFuel",attrs:{"status":"Fuel"}}):_vm._e(),(_vm.hasAccessAll(['c3a-default-setkendaraan:read']))?_c('OperationalNotes',{ref:"operationalNotes",attrs:{"status":"OperationalNotes"}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }